import { getIconByOptions } from '../Options/getIconByOptions.jsx';
import PasAvanceArgent from '@amo/core/assets/images/AMO_Icons/Pas-avance-argent.svg';

const IncludedGuarantees = ({ formuleChoisie }) => {
    const inclusionGaranties = formuleChoisie?.ListeGaranties?.filter(
        (g) => g.Disponible === 'Inclusion'
    ) || [];

    if (inclusionGaranties.length === 0) return null;

    return (
        <div style={{textAlign: 'left'}}>
            <div className="top-section-hd">
                <img src={PasAvanceArgent} alt="" loading="lazy" aria-hidden="true" />
                <div>
                    <h2 className="top-section-title">
                        Pour vous et votre 2-roues : tout ce qui est inclus dans votre assurance
                    </h2>
                    <div className="top-section-sub">
                        Détail de votre formule {formuleChoisie?.LibelleFormule}
                    </div>
                </div>
            </div>
            <div className="includes-grid">
                {inclusionGaranties.map((g, idx) => {
                    const icon = getIconByOptions(g.CodeGarantie);
                    return (
                        <div className="inc-item" key={idx}>
                            <div className="inc-ico">
                                {icon && (
                                    <img src={icon} alt="" loading="lazy" aria-hidden="true" />
                                )}
                            </div>
                            <div>
                                <div className="inc-title">{g.LibelleGarantie}</div>
                                {g.ConditionsIndemnisation && (
                                    <div className="inc-desc">{g.ConditionsIndemnisation}</div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default IncludedGuarantees;
